import React from 'react';
import styled from 'styled-components';
import { components } from 'react-select';
import type { OptionProps, OptionTypeBase } from 'react-select';
import StudentIcon from '../../charts/student-scatter/components/StudentIcon';
import { ICON_WRAPPER } from '../../../util/data-id';

const CustomStudentOption: React.FC<OptionProps<OptionTypeBase, false>> = ({
  ...props
}) => {
  return (
    <React.Fragment>
      <components.Option {...props}>
        <OptionIconWrapper className={'mr-sm'}>
          <StudentIcon size={'sm'} color={props.isSelected ? 'primary' : 'black'} />
        </OptionIconWrapper>
        {props.children}
      </components.Option>
    </React.Fragment>
  );
};

const OptionIconWrapper = styled('div')`
  [data-id='${ICON_WRAPPER}'] svg {
    margin-left: 0;
  } 
`;

export default CustomStudentOption;
